/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Global_Toggle_LabelInputs */

const es_components_credentials_global_toggle_label = /** @type {(inputs: Components_Credentials_Global_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso global`)
};

const en_components_credentials_global_toggle_label = /** @type {(inputs: Components_Credentials_Global_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global access`)
};

/**
* | output |
* | --- |
* | "Global access" |
*
* @param {Components_Credentials_Global_Toggle_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_global_toggle_label = /** @type {((inputs?: Components_Credentials_Global_Toggle_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Global_Toggle_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_global_toggle_label(inputs)
	return en_components_credentials_global_toggle_label(inputs)
});
export { components_credentials_global_toggle_label as "components.credentials.global.toggle_label" }